import React, {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, WithChildren} from '../../../../helpers'
import MenuIcon from "src/components/MenuIcon";

type Props = {
    to: string
    title: string
    hasBullet?: boolean
    disabled?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
                                                       children,
                                                       to,
                                                       title,
                                                       hasBullet = false,
                                                   }) => {
    const {pathname} = useLocation()
    const isActive = checkIsActive(pathname, to)

    return (
            <div className={clsx('SideBarMenuItem', {active: isActive})}>
                <Link data-kt-menu-trigger='click'
                      className={clsx('w-full flex justify-between items-center', {active: isActive})} to={to}>
                    <div className={"w-full flex flex-col gap-[2px] items-center"}>
                        <MenuIcon menu={title} isActive={isActive}/>
                        {hasBullet && (
                            <span className='menu-bullet'>
                                <span className='bullet bullet-dot'></span>
                            </span>
                        )}
                        <span>{title}</span>
                    </div>
                </Link>
                {children}
            </div>
    )
}

export {SidebarMenuItem}
